import { render, staticRenderFns } from "./VisibilityIcon.vue?vue&type=template&id=d630c24c&scoped=true&"
import script from "./VisibilityIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VisibilityIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630c24c",
  null
  
)

export default component.exports